import React from "react";
import "../styles/ServicesLists.css";

const NOTABLE_SERVICES = [
  "Document Translation",
  "Interpretation Services",
  "Website & App Localization",
  "Multimedia Subtitling & Voiceover",
  "Proofreading, Editing & Subtitling",
  "Language Courses",
  "Document Localization",
  "Legal Translation & Legalization",
  "Medical Translation",
  "IT & Software Translation",
  "E-commerce Translation",
  "Newspaper & Media Translation",
  "Marketing Translation",
  "Financial Translation",
  "Engineering Translation",
  "Advertisement Translation",
  "Marketing Translation",
  "E-commerce Translation",
  "Tourism Translation",
  "Product Description Translation",
  "Audio & Video Translation",
  "Branding Material Translation",
  "Multilingual Research",
  "Customer Support Translation",
  "Technical Translation",
  "Proofreading",
  "Academic Translation",
];

const CERTIFIED_FOR = [
  "Birth certificates",
  "Property Documents",
  "Marriage and divorce certificates",
  "Operating Manuals",
  "Academic transcripts and diplomas",
  "Medical Documents",
  "Driver’s Licenses",
  "Agreements & reports",
  "Medical records",
  "Sales contracts",
  "Business Documents",
  "Trademarks & copyrights",
  "Commercial Papers",
  "Certificates & affidavits",
  "Family Documents",
  "Financial Documents",
  "Insurance policies",
  "Professional Magazines",
  "Judicial orders",
  "Immigration Documents",
  "Service terms",
  "Legal Documents",
  "Notice of Eviction",
  "Police clearance certificate",
  "Personal Documents",
  "Employment references",
  "Website",
];

const ServicesLists = () => {
  return (
    <div className="services-lists" role="region" aria-labelledby="services-lists-title">
      <h2 id="services-lists-title" className="visually-hidden">
        Notable Services and Certified Translations For
      </h2>

      <div className="two-col">
        <div className="panel">
          <h3>Notable Services</h3>
          <ul className="items">
            {NOTABLE_SERVICES.map((item, idx) => (
              <li key={idx} className="pill">{item}</li>
            ))}
          </ul>
        </div>

        <div className="panel">
          <h3>Certified Translations For</h3>
          <ul className="items">
            {CERTIFIED_FOR.map((item, idx) => (
              <li key={idx} className="pill">{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ServicesLists;
